export class CancellationReason {
  reason: string;
  identifier: string;

  constructor(cancellationReasonData?: any) {
    if(cancellationReasonData){
      this.reason = cancellationReasonData.reason;
      this.identifier = cancellationReasonData.identifier;
    }
  }
}
